"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCT_ERROR_MESSAGES = void 0;
const globalErrorCode_1 = require("../../../global/model/error/globalErrorCode");
const globalErrorMessages_1 = require("../../../global/model/error/globalErrorMessages");
const productErrorCode_1 = require("./productErrorCode");
const PRODUCT_ERROR_MESSAGES = {};
exports.PRODUCT_ERROR_MESSAGES = PRODUCT_ERROR_MESSAGES;
PRODUCT_ERROR_MESSAGES[productErrorCode_1.ProductErrorCode.INVALID_SKU] =
    'The provided value for SKU is invalid. It must be a non-empty string';
PRODUCT_ERROR_MESSAGES[productErrorCode_1.ProductErrorCode.INVALID_NAME] =
    'The provided value for NAME is invalid. It must be a non-empty string';
PRODUCT_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN] =
    globalErrorMessages_1.GLOBAL_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN];
PRODUCT_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE] =
    globalErrorMessages_1.GLOBAL_ERROR_MESSAGES[globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE];
//# sourceMappingURL=productErrorMessages.js.map